import { themeAlpine } from "ag-grid-community";
// requestUserData
export const FETCH_USER_DATA_PENDING = "FETCH_USER_DATA_PENDING";
export const FETCH_USER_DATA_SUCCESS = "FETCH_USER_DATA_SUCCESS";
export const FETCH_USER_DATA_FAILED = "FETCH_USER_DATA_FAILED";

//requestLogout
export const FETCH_LOGOUT_PENDING = "FETCH_LOGOUT_PENDING";
export const FETCH_LOGOUT_SUCCESS = "FETCH_LOGOUT_SUCCESS";
export const FETCH_LOGOUT_FAILED = "FETCH_LOGOUT_FAILED";

//Backend URLS
export const USER_INFO_URL = process.env.REACT_APP_USER_INFO_URL;
export const LOGOUT_URL = process.env.REACT_APP_LOGOUT_URL;
export const LOGIN_THREELEGGED_URL =
  process.env.REACT_APP_LOGIN_THREELEGGED_URL;
export const SCHEDULES_URL = process.env.REACT_APP_SCHEDULES_URL;
export const HOST_URL = process.env.REACT_APP_HOST_URL;

//Frontend URLS
export const LOGIN_PAGE = process.env.REACT_APP_LOGIN_PAGE;
export const LOGIN_PAGE_EXTENSION = process.env.REACT_APP_LOGIN_PAGE_EXTENSION;

export const MAIN_PAGE = process.env.REACT_APP_MAIN_PAGE;
export const MAIN_PAGE_EXTENSION = process.env.REACT_APP_MAIN_PAGE_EXTENSION;

export const VIEWER_PAGE = process.env.REACT_APP_VIEWER_PAGE;
export const VIEWER_PAGE_EXTENSION =
  process.env.REACT_APP_VIEWER_PAGE_EXTENSION;

export const SETTINGS_PAGE = process.env.REACT_APP_SETTINGS_PAGE;
export const SETTINGS_PAGE_EXTENSION =
  process.env.REACT_APP_SETTINGS_PAGE_EXTENSION;

// export const VISUALISATION_PAGE = process.env.REACT_APP_VISUALISATION_PAGE;
// export const VISUALISATION_PAGE_EXTENSION =
//   process.env.REACT_APP_VISUALISATION_PAGE_EXTENSION;

export const PERSONALHUB_PAGE = process.env.REACT_APP_PERSONALHUB_PAGE;
export const PERSONALHUB_PAGE_EXTENSION =
  process.env.REACT_APP_PERSONALHUB_PAGE_EXTENSION;

// export const FIELD_PAGE = process.env.REACT_APP_FIELD_PAGE;
// export const FIELD_PAGE_EXTENSION = process.env.REACT_APP_FIELD_PAGE_EXTENSION;

// export const PSH_PAGE = process.env.REACT_APP_PSH_PAGE;
// export const PSH_PAGE_EXTENSION = process.env.REACT_APP_PSH_PAGE_EXTENSION;

export const HAZOP_PAGE = process.env.REACT_APP_HAZOP_PAGE;
export const HAZOP_PAGE_EXTENSION = process.env.REACT_APP_HAZOP_PAGE_EXTENSION;

export const HOME_PAGE = process.env.REACT_APP_HOME_PAGE;
export const HOME_PAGE_EXTENSION = process.env.REACT_APP_HOME_PAGE_EXTENSION;

export const HELP_PAGE = process.env.REACT_APP_HELP_PAGE;
export const HELP_PAGE_EXTENSION = process.env.REACT_APP_HELP_PAGE_EXTENSION;

//MWH URLS
export const MWH_MAIN_PAGE = "https://mwhtreatment.com/";

//BIM360 CREDENTIALS
export const HUB_ID = process.env.REACT_APP_HUB_ID;
export const RESOURCE_ID = process.env.REACT_APP_RESOURCE_ID;
export const PROJECT_NAME = process.env.REACT_APP_PROJECT_NAME;
export const PROJECT_ID = process.env.REACT_APP_PROJECT_ID;

//Styles
// export const STYLES_PAGE = process.env.REACT_APP_STYLES_PAGE;
// export const STYLES_PAGE_EXTENSION =
//   process.env.REACT_APP_STYLES_PAGE_EXTENSION;

//Viewer.js
export const TOKEN_URL = process.env.REACT_APP_TOKEN_URL;
export const PROJECTDATA_URL = process.env.REACT_APP_PROJECTDATA_URL;

export const LEGACY_MARKUP_CUTOFF = process.env.REACT_APP_LEGACY_MARKUP_CUTOFF;

export const MandatoryFieldIndicator = () => (
  <span className="text-danger" title="This field is required">
    *
  </span>
);

export const MandatoryExplanation = () => {
  return (
    <div className="row">
      <div className="col">
        <p className="mt-1 mb-0">
          Mandatory fields are marked with <MandatoryFieldIndicator />
        </p>
      </div>
    </div>
  );
};

export const markupCategories = [
  "For Information",
  "Civil 3D Model",
  "Electrical 3D Model",
  "Mechanical 3D Model",
  "Process 3D Model",
  "Civil Drawing",
  "Electrical Drawing",
  "Mechanical Drawing",
  "Process Drawing",
  "Multi-Discipline Review 3D Model",
  "Multi-Discipline Review Drawing",
  "ALM",
];

export const projectConfigEditRights = [
  "Design Manager",
  "Admin",
  "Civil Approver",
  "Mechanical Approver",
  "Electrical Approver",
  "Process Approver",
  "Structural Approver",
];

//Role information
export const civilRoles = [
  "Civil CAD",
  "Civil Checker", // need this one or just CAD and DM?
  "Civil Reviewer", // need this one or just CAD and DM?
  "Civil Approver", // need this one or just CAD and DM?
  "Design Manager",
  "Admin",
];
export const mechRoles = [
  "Mechanical CAD",
  "Mechanical Checker", // need this one or just CAD and DM?
  "Mechanical Reviewer", // need this one or just CAD and DM?
  "Mechanical Approver", // need this one or just CAD and DM?
  "Design Manager",
  "Admin",
];
export const elecRoles = [
  "Electrical CAD",
  "Electrical Checker", // need this one or just CAD and DM?
  "Electrical Reviewer", // need this one or just CAD and DM?
  "Electrical Approver", // need this one or just CAD and DM?
  "Design Manager",
  "Admin",
];
export const processRoles = [
  "Process Checker", // need this one or just CAD and DM?
  "Process Reviewer", // need this one or just CAD and DM?
  "Process Approver", // need this one or just CAD and DM?
  "Design Manager",
  "Admin",
];

export const structuralRoles = [
  "Structural CAD",
  "Structural Checker",
  "Structural Reviewer",
  "Structural Approver",
  "Design Manager",
  "Admin",
];

export const generalRoles = [
  "Civil CAD",
  "Civil Checker",
  "Civil Reviewer",
  "Civil Approver",
  "Mechanical CAD",
  "Mechanical Checker",
  "Mechanical Reviewer",
  "Mechanical Approver",
  "Electrical CAD",
  "Electrical Checker",
  "Electrical Reviewer",
  "Electrical Approver",
  "Structural CAD",
  "Structural Checker",
  "Structural Reviewer",
  "Structural Approver",
  "Process Checker",
  "Process Reviewer",
  "Process Approver",
  "Design Manager",
  "Admin",
];

export const subContractorRoles = ["Design Manager", "Admin"];

export const submittalFileTypes = [
  { name: "Revit", code: ".rvt" },
  { name: "Navisworks (D)", code: ".nwd" },
  { name: "IFC", code: ".ifc" },
  { name: "STP", code: ".stp" },
  { name: "Navisworks (C)", code: ".nwc" },
  { name: "DWFX", code: ".dwfx" },
  { name: "AutoCAD / Civil 3D", code: ".dwg" },
  { name: "Navisworks (F)", code: ".nwf" },
  { name: "Bentley Microstation", code: ".dgn" },
  { name: "Microsoft Word", code: ".doc" },
  { name: "Microsoft Excel", code: ".xlsx" },
];

export const agGridTheme = themeAlpine;

export const agGridOptionsSingle = {
  autoSizeStrategy: {
    type: "fitCellContents",
    skipHeader: false,
  },
  rowSelection: {
    mode: "singleRow",
    enableClickSelection: "enableSelection",
  },
  animateRows: true,
  pagination: true,
  paginationPageSize: 10,
  paginationPageSizeSelector: [10, 20, 50, 100],
};

export const agGridOptionsMultiple = {
  autoSizeStrategy: {
    type: "fitCellContents",
    skipHeader: false,
  },
  rowSelection: {
    mode: "multiRow",
    enableClickSelection: "enableSelection",
  },
  animateRows: true,
  pagination: true,
  paginationPageSize: 10,
  paginationPageSizeSelector: [10, 20, 50, 100],
};

export const agGridOptionsNone = {
  autoSizeStrategy: {
    type: "fitCellContents",
    skipHeader: false,
  },
  animateRows: true,
  pagination: true,
  paginationPageSize: 10,
  paginationPageSizeSelector: [10, 20, 50, 100],
};

//REACT SELECT CUSTOM STYLES
export const customStyles = {
  control: (provided, state) => ({
    ...provided,
    background: "#fff",
    borderColor: "#9e9e9e",
    minHeight: "30px",
    height: "30px",
    boxShadow: state.isFocused ? null : null,
  }),

  option: (styles) => {
    const color = "rgb(0, 0, 0)";
    // const color2 = "rgba(0, 0, 0, 0.3)";
    return {
      ...styles,
      color: color,
    };
  },

  valueContainer: (provided, state) => ({
    ...provided,
    height: "30px",
    padding: "0 6px",
  }),

  input: (provided, state) => ({
    ...provided,
    margin: "0px",
  }),
  indicatorSeparator: (state) => ({
    display: "none",
  }),
  indicatorsContainer: (provided, state) => ({
    ...provided,
    height: "30px",
  }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
};

export const calculateNextDueDate = (
  lastPerformedDate,
  dimension,
  interval,
) => {
  if (!lastPerformedDate || !interval || !dimension) return null;
  let nextDueDate = new Date(lastPerformedDate);
  switch (dimension) {
    case "D":
      nextDueDate.setDate(lastPerformedDate.getDate() + interval);
      break;
    case "W":
      nextDueDate.setDate(nextDueDate.getDate() + 7 * interval);
      break;
    case "M":
      nextDueDate.setMonth(nextDueDate.getMonth() + interval);
      break;
    case "Y":
      nextDueDate.setFullYear(nextDueDate.getFullYear() + interval);
      break;
    case "H":
      nextDueDate.setHours(nextDueDate.getHours() + interval);
      break;
    default:
      return null;
  }

  return nextDueDate.toISOString();
};
export const stringToCamelCase = (str) => {
  return str
    .toLowerCase()
    .replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, (match, index) =>
      index === 0 ? match.toLowerCase() : match.toUpperCase(),
    )
    .replace(/\s+/g, "");
};
